const baseUrl =
  process.env.NEXT_PUBLIC_BASE_URL || process.env.NEXT_PUBLIC_VERCEL_URL;

// vercel deploy url is difference from real url and it will contain price-rank.dev
function getDefaultLocale() {
  if (
    /(vn.price-rank.dev|vn-price-rank-dev|vn-team.morizyun.com)/.test(baseUrl)
  ) {
    return "vn";
  }

  if (/(price-rank.dev|price-rank-dev|team.morizyun.com)/.test(baseUrl)) {
    return "en";
  }

  return "ja";
}

function getSupportedLocale() {
  if (/(price-rank.dev|price-rank-dev|team.morizyun.com)/.test(baseUrl)) {
    return ["en", "ja", "vn"];
  }

  return ["en", "ja"];
}

module.exports = {
  defaultLocale: getDefaultLocale(),
  loader: false,
  locales: getSupportedLocale(),
  logBuild: false,
  pages: {
    "rgx:/*": ["common", "metaInfo", "frontPage"],
    "rgx:/creators/*": ["creator"],
    "rgx:/qa/*": ["topic"],
    "rgx:/qa/.*/review$": ["form", "question", "talkRoom"],
    "rgx:/questions/post/*": ["form"],
  },
};
